export default {"src":"/_next/static/media/overheadEquipmentLabels.a3b38c67.svg","height":720,"width":1080,"blurWidth":0,"blurHeight":0};